import apiClient from '../apiClient';

export const getMetadataFieldsByCustomer = (customerId) => {
  return apiClient.get(`/metadatafields/customer/${customerId}/metadata`);
};

export const getMetadataField = (id) => {
  return apiClient.get(`/metadatafields/${id}`);
};

export const createMetadataField = (fieldData) => {
  return apiClient.post('/metadatafields', fieldData);
};

export const updateMetadataField = (id, fieldData) => {
  return apiClient.put(`/metadatafields/${id}`, fieldData);
};

export const deleteMetadataField = (id) => {
  return apiClient.delete(`/metadatafields/${id}`);
};